export const checkUnitVersion = (unitServices) => {
  const swVersion = 7.1;
  const unitVersion = unitServices?.sw_version
    ?.split(/[_.]/)
    ?.filter((e) => !isNaN(e) && e)
    ?.slice(0, 2)
    ?.join('.');
  return +unitVersion > swVersion;
};
